import { FormDataModel, FormState, RootState } from '../types'

export const SAVE_FORM_DATA = 'form//SAVE_FORM_DATA'

interface SaveFormDataAction {
  type: typeof SAVE_FORM_DATA
  payload: Partial<FormDataModel>
}

type FormActions = SaveFormDataAction

export function saveFormData(data: Partial<FormDataModel>): SaveFormDataAction {
  return {
    type: SAVE_FORM_DATA,
    payload: data,
  }
}

export function getFormData(store: RootState): FormState['data'] {
  return store.form.data
}

const initialState: FormState = {
  data: {},
}

// eslint-disable-next-line func-names
export default function formReducer(
  state: FormState | undefined,
  action: FormActions
): FormState {
  const currentState = state || initialState
  switch (action.type) {
    case SAVE_FORM_DATA:
      return {
        ...currentState,
        data: {
          ...currentState.data,
          ...action.payload,
        },
      }

    default:
      return currentState
  }
}
